import { render, staticRenderFns } from "./templateHeader.vue?vue&type=template&id=53b91d14&scoped=true"
import script from "./templateHeader.vue?vue&type=script&lang=js"
export * from "./templateHeader.vue?vue&type=script&lang=js"
import style0 from "./templateHeader.vue?vue&type=style&index=0&id=53b91d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b91d14",
  null
  
)

export default component.exports